import { render, staticRenderFns } from "./commentItem.vue?vue&type=template&id=72e5e2de&scoped=true&"
import script from "./commentItem.vue?vue&type=script&lang=js&"
export * from "./commentItem.vue?vue&type=script&lang=js&"
import style0 from "./commentItem.vue?vue&type=style&index=0&id=72e5e2de&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e5e2de",
  null
  
)

export default component.exports